import axios from 'axios'
import { interceptorRequest, handlerErrorRequest } from './interceptors'

const api = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
})

api.interceptors.request.use(interceptorRequest, handlerErrorRequest)

export default api
